import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { listMessagesByRoomAction } from '@state/messages/messages.actions';
import { selectMessagesPageOf } from '@state/messages/messages.selectors';

@UntilDestroy()
@Component({
  selector: 'app-user-notifications-bell',
  templateUrl: './user-notifications-bell.component.html',
  styleUrls: ['./user-notifications-bell.component.scss'],
})
export class UserNotificationsBellComponent implements OnInit {
  @Input() external = false;
  protected newMessagesCount = 0;

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      listMessagesByRoomAction({
        sort: [{ field: 'UPDATED_AT', order: 'DESC' }],
      })
    );

    this.store
      .select(selectMessagesPageOf)
      .pipe(untilDestroyed(this))
      .subscribe((pageOf) => {
        this.newMessagesCount =
          pageOf?.results.filter((message) => !message.seen).length || 0;
      });
  }

  protected onMessagesClick(event: MouseEvent): void {
    if (this.router.url.startsWith('/my-messages')) {
      event.preventDefault();
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/my-messages']));
    }
  }
}
